export const EXISTS = 1;
export const REMOVED = 0;
export const INACTIVE = 2;
